import { useCallback, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

type CursorUpdater = Date | ((prev: Date) => Date)

// Mês exibido (navegação por mês) PERSISTIDO na URL como `?m=YYYY-MM`. Antes cada
// tela guardava o mês só em useState → um F5 voltava pro mês atual. Guardar na URL
// sobrevive ao refresh, funciona com voltar/avançar do navegador e é compartilhável.
// O `set` aceita Date OU updater (mesma assinatura do setState antigo), então as
// telas só trocam `useState(() => new Date())` por `useMonthCursor()`. Dia = 01.
export function useMonthCursor(): [Date, (next: CursorUpdater) => void] {
  const [params, setParams] = useSearchParams()

  const cursor = useMemo(() => {
    const m = params.get('m')
    if (m) {
      const [y, mo] = m.split('-').map(Number)
      if (y && mo >= 1 && mo <= 12) return new Date(y, mo - 1, 1)
    }
    return new Date()
  }, [params])

  const setCursor = useCallback(
    (next: CursorUpdater) => {
      const nd = typeof next === 'function' ? next(cursor) : next
      const ym = `${nd.getFullYear()}-${String(nd.getMonth() + 1).padStart(2, '0')}`
      setParams(
        (prev) => {
          const p = new URLSearchParams(prev)
          p.set('m', ym)
          return p
        },
        { replace: true }, // navegar entre meses não polui o histórico do navegador
      )
    },
    [cursor, setParams],
  )

  return [cursor, setCursor]
}
